/* eslint-disable */
import { FormHelperText, Grid, InputAdornment, TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import withServices from '../../Contexts/Services/WithServices.context';
import getFiltersSelectedAccount from '../../State/Store/Filters/Selectors/FiltersSelectedAccount.selector';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_SITE_CONTACT_NAME_BLUR, UI_SITE_CONTACT_NAME_FOCUS, UI_SITE_CONTACT_PHONE_BLUR, UI_SITE_CONTACT_PHONE_FOCUS } from '../../State/Store/UI/UI.types';
import userProfileSelector from '../../State/Store/UserProfile/Selectors/UserProfileCurrent.selector';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import CustomPhoneInput from '../CustomPhoneInput/CustomPhoneInput.component';
import placeOrderStyles from './PlaceOrder.component.styles';

/**
 * SiteContact
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const SiteContact = ({ actions, classes, onChange, services, userInfo, defaultName, defaultPhoneNumber }) => {
  const [userInfoLoaded, setUserInfoLoaded] = useState(false);
  const [userName, setUserName] = useState(null);
  const [userPhoneNumber, setUserPhoneNumber] = useState(null);
  const [isValid, setIsValid] = useState(true);

  /**
   * Phone number handler
   * @param {string} phoneNumber phone number
   * @param {string} errorText error text
   * @returns {void} void
   */
  const phoneNumberHandler = (phoneNumber, errorText) => {
    setUserPhoneNumber(phoneNumber);
    setIsValid(!errorText);
    onChange({ isValid: !errorText, selectedPhoneNumber: phoneNumber, selectedName: userName });
    return;
  };

  /**
   * Name handler
   * @param {string} contactName contact name
   * @returns {void} void
   */
  const nameHandler = (contactName) => {
    setUserName(contactName);
    onChange({ isValid, selectedPhoneNumber: userPhoneNumber, selectedName: contactName || `` });
    return;
  };

  /**
   * Handles event
   * @returns {void} void
   */
  const nameBlurHandler = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `siteContactNameBlur`,
        },
      },
      type: UI_SITE_CONTACT_NAME_BLUR,
    });
    return;
  };

  /**
   * Handles event
   * @returns {void} void
   */
  const nameFocusHandler = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `siteContactNameFocus`,
        },
      },
      type: UI_SITE_CONTACT_NAME_FOCUS,
    });
    return;
  };

  /**
   * Handles event
   * @returns {void} void
   */
  const phoneBlurHandler = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `siteContactPhoneBlur`,
        },
      },
      type: UI_SITE_CONTACT_PHONE_BLUR,
    });
    return;
  };

  /**
   * Handles event
   * @returns {void} void
   */
  const phoneFocusHandler = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `siteContactPhoneFocus`,
        },
      },
      type: UI_SITE_CONTACT_PHONE_FOCUS,
    });
    return;
  };

  useEffect(() => {
    if (defaultName || defaultPhoneNumber) {
      setUserName(defaultName);
      setUserPhoneNumber(defaultPhoneNumber);
      setUserInfoLoaded(true);
      return;
    }
    (async () => {
      try {
        const currentUserInfo = await services.userService.getCurrentUser();
        if (currentUserInfo && currentUserInfo.displayName) {
          setUserName(currentUserInfo.displayName);
        }
        if (currentUserInfo && currentUserInfo.mobilePhone) {
          setUserPhoneNumber(currentUserInfo.mobilePhone);
        }
        onChange({
          isValid: true,
          selectedPhoneNumber: currentUserInfo && currentUserInfo.mobilePhone ? currentUserInfo.mobilePhone : ``,
          selectedName: currentUserInfo && currentUserInfo.displayName ? currentUserInfo.displayName : ``,
        });
        setUserInfoLoaded(true);
      } catch (err) {
        onChange({ isValid: true, selectedPhoneNumber: ``, selectedName: (userInfo && userInfo.displayName) || `` });
      }
    })();
  }, []);

  return (
    <React.Fragment>
      <Grid item className={classes.switches}>
        <Grid container alignItems="center">
          <Grid item className={classes.flexGrow1}>
            <TextField
              fullWidth
              id="name"
              value={userName || ``}
              label="Site Contact Name"
              onBlur={nameBlurHandler}
              onFocus={nameFocusHandler}
              className={classes.spacingField}
              placeholder="Enter Name"
              onChange={(e) => nameHandler(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PermContactCalendarIcon className={classes.opacity05} />
                  </InputAdornment>
                ),
              }}
            />
            <FormHelperText>Enter the name of the on-site contact</FormHelperText>
          </Grid>
        </Grid>
        {userInfoLoaded && (
          <React.Fragment>
            <CustomPhoneInput
              emptyValid
              fullWidth
              onBlur={phoneBlurHandler}
              onFocus={phoneFocusHandler}
              id="phoneNumber"
              label="Site Contact Phone"
              onPhoneNumberChange={(newId, newValue, errorText) => {
                phoneNumberHandler(newValue, errorText);
              }}
              value={userPhoneNumber}
            />
            <FormHelperText className={classes.phoneHelperText}>Enter the phone number of the on-site contact</FormHelperText>
          </React.Fragment>
        )}
      </Grid>
    </React.Fragment>
  );
};

/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
SiteContact.propTypes = {
  actions: PropTypes.object.isRequired,
  userInfo: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  services: PropTypes.object.isRequired,
  defaultName: PropTypes.string,
  defaultPhoneNumber: PropTypes.string,
};

export default compose(
  withWidth(),
  withRouter,
  withServices,
  connect(
    (state) => ({
      listSettings: state.dockets ? state.dockets.listSettings : null,
      userInfo: userProfileSelector(state),
      currentDateTimeGlobal: getFiltersSelectedAccount(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
        },
        dispatch,
      ),
    }),
  ),
  withStyles(themeCreateInjectableStyles(placeOrderStyles), { withTheme: true }),
)(SiteContact);
